import { useEffect, useState } from "react";
import { ArrowRight, Monitor } from "lucide-react";
import { ActionLink } from "@omnicanvas/ui";
import { TrialPromise } from "./TrialPromise";

export function CTA() {
  const [isWindows, setIsWindows] = useState(false);

  useEffect(() => {
    setIsWindows(/windows/i.test(navigator.userAgent));
  }, []);

  return (
    <section id="cta" className="bg-white py-24 md:py-32">
      <div className="mx-auto max-w-5xl px-6">
        <div className="overflow-hidden rounded-3xl bg-slate-950 px-8 py-14 text-center shadow-[0_30px_70px_-40px_rgba(15,23,42,0.8)] md:px-16 md:py-20">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-indigo-300">
            See the outcome now
          </p>
          <h2 className="mx-auto mt-4 max-w-2xl text-4xl font-extrabold tracking-[-0.035em] text-white md:text-5xl">
            Try a real workspace before you sign up.
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base leading-7 text-slate-300">
            Open a populated canvas in OmniCanvas and work in it right away. No
            account needed.
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
            <ActionLink
              href="https://app.omnicanvasnotes.com/?mode=try&template=brainstorm-web&utm_source=marketing&utm_medium=cta&utm_campaign=live_canvas"
              size="lg"
              className="group bg-white text-slate-950 hover:bg-slate-100"
            >
              Try a live canvas — no account
              <ArrowRight size={17} className="transition-transform group-hover:translate-x-0.5" />
            </ActionLink>
            <a
              href="https://app.omnicanvasnotes.com/?mode=try&action=sample-meeting&utm_source=marketing&utm_medium=cta&utm_campaign=interactive_sample"
              className="text-sm font-semibold text-slate-300 underline-offset-4 hover:text-white hover:underline"
            >
              Or try a sample meeting
            </a>
            <a
              href="/pricing"
              className="text-sm font-semibold text-slate-300 underline-offset-4 hover:text-white hover:underline"
            >
              Compare plans
            </a>
          </div>
          {isWindows && (
            <a
              href="https://app.omnicanvasnotes.com/api/downloads/windows-latest.exe"
              className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-slate-400 hover:text-white"
            >
              <Monitor size={15} />
              Download the Windows app
            </a>
          )}
        </div>
        <TrialPromise className="mt-8" />
      </div>
    </section>
  );
}
